// extracted by mini-css-extract-plugin
export default {"list":"SQVC3uz52XuguKFzatT_","secondary":"XIWGJ_68cH_1l56j1AVw"};